<template>
  <div class="_rfp_mctb_cm_01_ rfp-mctb-carousel-mode-header vue-tabs">
    <div class="_rfp_mctb_cm_02_ rfp-mctb-carousel-mode-header-top-header">
      {{ carouselHeaderText }}
    </div>

    <section
      v-if="storeLocatorModeOptions.Product.Retailers.length === 0"
      class="_rfp_mctb_list_0018_ tab-container"
    >
      <ul role="generic" class="_rfp_mctb_list_0013_">
        <li role="generic" class="retailer__unavailable">
          <div class="retailer-unavailable_01">
            {{ retailerUnavailable }}
          </div>
        </li>
      </ul>
    </section>

    <template v-else>
      <div v-if="showTabs" class="_rfp_mctb_list_006_ nav-tabs-navigation">
        <div class="_rfp_mctb_list_007_ nav-tabs-wrapper">
          <ul role="tablist" class="_rfp_mctb_list_008_ nav nav-tabs">
            <li
              v-for="(country, index) in countriesWithRetailers"
              :id="country.DisplayName"
              :key="country.DisplayName"
              role="tab"
              tabindex="0"
              :aria-selected="String(index === activeTabIndex)"
              aria-controls="rfp-mctb-retailer-tabpanel"
              class="_rfp_mctb_list_009_ tab active"
              :class="{ active__tab: index === activeTabIndex }"
              @keydown.space.prevent="setActiveTab(index)"
              @keydown.enter="setActiveTab(index)"
              @click="setActiveTab(index)"
            >
              <span class="_rfp_mctb_list_0010_ active_tab tabs__link">
                <span class="_rfp_mctb_list_0011_ title title_center">
                  {{ country.DisplayName }}
                </span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div id="rfp-mctb-retailer-tabpanel" :role="showTabs ? 'tabpanel' : null">
        <rfp-mctb-carousel
          :key="activeTabCountry?.Name"
          :enable-rtl="enableRtl"
          :autoplay="false"
          :autoplay-timeout="10000"
          :loop="false"
          :autoplay-hover-pause="true"
          :min-swipe-distance="8"
          pagination-active-color="#f30606"
          pagination-color="#efefef"
          :pagination-padding="10"
          :pagination-size="10"
          :per-page="1"
          :navigation-enabled="true"
          :pagination-enabled="false"
          :productname="productname"
          :productids="productids"
          :slide-count="computedRetailers.length"
        >
          <rfp-mctb-slide
            v-for="retailer in computedRetailers"
            :key="retailer.Name"
            :enable-rtl="enableRtl"
          >
            <div class="_rfp_mctb_cm_03_ rfp-mctb-slider-outer">
              <div class="_rfp_mctb_cm_04_ rfp-mctb-slider-description rfp-mctb-image-alignment">
                <img
                  class="_rfp_mctb_cm_05_ rfp-mctb-button-image"
                  :src="retailer.Logo"
                  :alt="retailer.LogoAlt"
                />
              </div>
              <p
                class="_rfp_mctb_cm_06_ rfp-mctb-slider-description"
                v-html="retailer.Description"
              ></p>
              <button
                class="_rfp_mctb_cm_07_ rfp-mctb-common-buynow"
                @click="
                  pageRedirectUrl(
                    retailer.RetailerUrl,
                    retailer.OpenInNewWindow,
                    retailer.RetailerTags,
                    retailer.RetailerTagsGS,
                    retailer.Name,
                  )
                "
              >
                <span class="_rfp_mctb_cm_08_ rfp-mctb-button-text"> {{ retailer.Name }} </span>
              </button>
            </div>
          </rfp-mctb-slide>
        </rfp-mctb-carousel>
      </div>
    </template>
  </div>
</template>

<script>
import eventBus from '@refapp/eventbus-js';
import RfpMctbCarousel from '../rfp-mctb-slider/rfp-mctb-carousel.vue';
import RfpMctbSlide from '../rfp-mctb-slider/rfp-mctb-slide.vue';
import ServiceType from '../rfp-mctb-tags/tagging-service-type';

export default {
  name: 'rfp-mctb-carousel-mode',
  components: {
    RfpMctbCarousel,
    RfpMctbSlide,
  },
  props: {
    storeLocatorModeOptions: {
      type: Object,
      required: true,
    },
    carouselHeaderText: {
      type: String,
      default: 'Choose a Retailer',
    },
    enableRtl: {
      type: Boolean,
      required: true,
    },
    retailerUnavailable: {
      type: String,
      required: true,
    },
    productname: {
      type: String,
      required: true,
    },
    productids: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      eventProjectDataLayer: {},
      activeTabIndex: 0,
    };
  },
  computed: {
    countriesWithRetailers() {
      return this.storeLocatorModeOptions.CountryList.filter((item) => {
        return item.Name in this.retailersByCountryName;
      });
    },
    activeTabCountry() {
      return this.countriesWithRetailers[this.activeTabIndex];
    },
    retailersByCountryName() {
      return this.storeLocatorModeOptions.Product.Retailers.reduce((acc, item) => {
        (acc[item.Country] ||= []).push(item);
        return acc;
      }, {});
    },
    activeCountryTabRetailers() {
      return this.retailersByCountryName[this.activeTabCountry?.Name] || [];
    },
    computedRetailers() {
      if (this.countriesWithRetailers.length > 0) {
        return this.activeCountryTabRetailers;
      }
      return this.storeLocatorModeOptions.Product.Retailers || [];
    },
    showTabs() {
      return this.storeLocatorModeOptions.CountryList.length > 1;
    },
  },
  created() {
    eventBus.on('rfp-mctb-datalayer-event', (val) => {
      this.eventProjectDataLayer = val;
    });
    eventBus.on('rfp-mctb-extra-param-component', (val) => {
      this.extraParams = val;
    });
    eventBus.emit('rfp-mctb-extra-param-component1');
  },
  methods: {
    pageRedirectUrl(redirectURL, OpenInNewWindow, standardTagsString, gsTagsString, retailerName) {
      const service = window.dataLayer ? ServiceType.GA : ServiceType.GSQ;

      try {
        const tags = JSON.parse(window.dataLayer ? standardTagsString : gsTagsString);
        tags &&
          eventBus.emit('rfpTaggingFoundation', {
            data: tags,
            values: {
              productName: this.productname,
              productId: this.productids,
              retailerName: retailerName,
            },
            extraParams: this.extraParams,
            service,
          });
      } catch (e) {
        console.error(
          `error/rfp-mctb-carousel-mode#pageRedirectUrl: ${service} tag parsing failed`,
          e,
        );
      }

      const target = OpenInNewWindow === true ? '_blank' : '_self';
      window.open(redirectURL, target);
    },
    setActiveTab(index) {
      this.activeTabIndex = index;
    },
  },
};
</script>
